import { Container, Stack } from "@chakra-ui/react";
import * as React from "react";
import { LuEye, LuShare2 } from "react-icons/lu";
import { Link } from "react-router";

import { Button } from "../components/chakra/button";
import { toaster } from "../components/chakra/toaster";
import { SectionHeader } from "../components/section-header";
import { useTitle, useWorkspace, useWorkspaceLink } from "../hooks";
import { WorkspaceLayout } from "../layouts/workspace";

export const DashboardPage = () => {
  const workspace = useWorkspace()!;
  const workspaceLink = useWorkspaceLink();
  const handleCopyCreatorUrl = React.useCallback(async () => {
    const url = `${window.location.origin}/creators/${workspace.slug}`;
    await navigator.clipboard.writeText(url);
    toaster.create({
      type: "success",
      title: "Creator URL copied",
      duration: 2000,
    });
  }, [workspace]);

  useTitle(workspace.name);
  return (
    <WorkspaceLayout>
      <Container maxW="4xl" pt="8">
        <SectionHeader
          title="Dashboard"
          subtitle="Share your creator URL with your audience to let them download the files they have access to."
        />
        <Stack direction="row" gap={2}>
          <Button colorPalette="gray" mt="4" size="sm" asChild>
            <Link to={workspaceLink("/preview")}>
              <LuEye />
              Preview Creator Page
            </Link>
          </Button>
          <Button onClick={handleCopyCreatorUrl} mt="4" size="sm">
            <LuShare2 />
            Copy Creator Page URL
          </Button>
        </Stack>
      </Container>
    </WorkspaceLayout>
  );
};
